module.exports = __webpack_public_path__ + "static/media/contact.aad55f71.jpg";